<template>
    <article class="wrapper" id="app" v-cloak>
        <div class="inner-wrapper" :class="{ 'no-scroll': isLockPage }">
            <header class="header">
                <div class="img-wr" :style="headWrStyle">
                    <img class="imgauto" v-lazy="headBgImg.img" alt="">
                </div>

                <div class="rule-btn" :style="[bgColor]" @click="showRule">
                    <p class="btn-text">活动规则</p>
                </div>
            </header>

            <main class="main">
                <section class="card coupon-wr">
                    <div class="coupon" :style="couponWrStyle">
                        <img class="imgauto" v-lazy="couponImg.img" alt="">
                    </div>

                    <div class="receive-btn" :style="receiveBtn" @click="receivePrize">
                        <img class="imgauto" v-lazy="receiveBtnImg.img" alt="">
                        <p class="receive-text" v-text="receiveBtnText"></p>
                    </div>
                </section>

                <section class="card">
                    <div :style="processStyle">
                        <img class="imgauto" v-lazy="processInfo.img" alt="">
                    </div>
                </section>

                <section class="card">
                    <div :style="fqlAmountStyle">
                        <img class="imgauto" v-lazy="fqlAmountInfo.img" alt="">
                    </div>
                </section>
            </main>
        </div>

        <!-- 登录弹层 -->
        <section class="mask" v-show="isShowLoginBox" @touchmove.prevent>
            <div class="login-box">
                <div class="box-title">
                    <p class="main-title" v-text="loginLayerMainTitle"></p>
                    <p class="sub-title" v-text="loginLayerSubTitle"></p>
                </div>
                <ul class="input-box">
                    <li>
                        <!-- 输入手机号码区域 -->
                        <div class="input-wrap">
                            <input v-model.trim="mobile" type="tel" maxlength="11" placeholder="输入手机号码" @blur="scrollToTop">
                        </div>
                    </li>

                    <li>
                        <!-- 发送短信验证码区域 -->
                        <div class="input-wrap">
                            <input v-model.trim="smsCode" type="tel" maxlength="6" placeholder="输入短信验证码" @blur="scrollToTop">
                        </div>
                        <!-- 此节点加上class="gray"后文字置灰 -->
                        <p class="msg-code" :class="smsCodeClass" :style="[textColor]" v-text="sendText" @click="clickSendBtn"></p>
                    </li>
                </ul>
                <div class="agree-box">
                    <p class="agree">点击按钮即代表您已阅读并同意<span :style="[textColor]" @click="showAgreement">分期乐服务协议</span></p>
                </div>
                <div class="box-btn" :style="[bgColor]" v-text="loginLayerBtnText" @click="submit"></div>
                <div class="box-close" @click="hideLoginBox">
                    <!-- 关闭按钮 -->
                </div>
            </div>
        </section>

        <!-- 用户注册协议 -->
        <section class="agreement" @touchmove.prevent>
            <div :class="agreementClass" @click="hideAgreement">
                <ul class="agreement-list">
                    <li v-for="(protocol, index) in protocolList" :key="index" v-text="protocol.name" @click="jumpToProtocol(protocol.url)"></li>
                    <li @click="hideAgreement">取消</li>
                </ul>
            </div>
        </section>

        <!-- 活动规则弹层 -->
        <section class="mask" v-show="isShowRule">
            <div class="rule-box">
                <h2 class="box-title">活动规则</h2>
                <ul class="rule-list">
                    <li class="rule-item" v-for="(list, index) in ruleList" :key="index" v-text="list"></li>
                </ul>
                <div class="box-btn" :style="[bgColor]" v-text="ruleLayerBtnText" @click="hideRule"></div>
                <div class="box-close" @click="hideRule">
                    <!-- 关闭按钮 -->
                </div>
            </div>
        </section>

        <!-- 乐信验证弹窗 -->
        <div class="captcha-box" id="captcha-box"></div>
    </article>
</template>

<script>
// 接口文档：http://wiki.fenqile.com/pages/viewpage.action?pageId=36408266

import Global from '@/global/index';
import Stat from '@/module/stat/2.0.0/stat.js';
import Util from '@/module/app/1.0.1/app.js';
import Url from '@/module/url/1.0.0/url';
import AgentSource from '@/module/agent_source/1.0.0/agent_source.js';
import reportJsError from '@/global/js_report.js';
import Config from './js/config.js';

const G_EVENT_ID = Config.G_EVENT_ID;
const G_EVENT_KEY = Config.G_EVENT_KEY;
const EI21006 = '参数不存在';
const SUCCEED_PAGE = `/page/${G_EVENT_KEY}/succeed.html`;
const PRIZE_PAGE = `/page/${G_EVENT_KEY}/prize.html`;

export default {
    name: 'app',
    components: {},
    data() {
        return {
            source: Url.get('source') || '',                // 入口source
            configData: {},                                 // 活动配置信息
            loadingIns: null,                               // loading对象
            isLogin: 0,                                     // 用户登录态

            activityId: Url.get('activity_id') || 0,        // 联合活动id
            agent: Url.get('agent') || '',                  // 渠道码
            agentSource: '',                                // 场景值
            hasCreditPageLink: '',                          // 联合活动-已授信用户跳转链接
            headBgImg: {},                                  // 头部背景图
            couponImg: {},                                  // 奖品图片
            receiveBtnImg: {},                              // 领取按钮图片
            receiveBtnText: '',                             // 领取按钮文案
            processInfo: {},                                // 领取流程描述信息
            fqlAmountInfo: {},                              // 分期乐额度介绍描述信息
            pageThemeColor: '',                             // 统一主题颜色
            loginLayerMainTitle: '',                        // 登录弹层主文案
            loginLayerSubTitle: '',                         // 登录弹层副文案
            loginLayerBtnText: '',                          // 登录弹层按钮文案
            ruleLayerBtnText: '',                           // 规则弹层按钮文案
            ruleList: [],                                   // 规则列表
            protocolList: [],                               // 协议列表

            isLockPage: false,                              // 是否禁止页面滚动
            isShowLoginBox: false,                          // 是否显示登录弹层
            isShowRule: false,                              // 是否显示规则弹层
            isShowAgreement: false,                         // 是否展示用户协议弹层
            authLink: 'https://auth.fenqile.com/agent/index.html',  // 授信入口
            systemData: {                                   // 平台免密注册接口要求参数
                new_version: '',
                uid: '',
                sign: '',
                os: 'H5',
                session_id: '',
                controller: 'accountRegisterService',
                token_id: '',
                time_stamp: new Date().getTime(),
                machine_code: '',
                channel_id: ''
            },
            channelFlag: Url.get('channel_flag') || 10,     // 用户注册渠道来源
            mobile: '',                                     // 手机号码
            verifiedMobile: '',                             // 已发送短信验证码的手机号
            smsCode: '',                                    // 短信验证码
            countDownTimer: '',                             // 定时器对象
            sendText: '获取验证码',
            isSendSms: false,                               // 是否发送成功短信
            verifyType: '',                                 // 手机号注册还是登录, 短信验证码验证类型
            isSubLock: false,                               // 重复提交限制
            
            appId: '',
            isLexinCaptchaPass: false,                      //乐信平台校验是否通过
            isLexinCaptchaInit: false,                      //是否正在初始化乐信平台校验
            lexinCaptcha: null
        };
    },
    computed: {
        // 元素统一主题背景颜色
        bgColor() {
            return {
                backgroundColor: this.pageThemeColor
            };
        },
        // 元素统一主题字体颜色
        textColor() {
            return {
                color: this.pageThemeColor
            };
        },
        // 顶部背景图样式
        headWrStyle() {
            return {
                height: `${parseInt(this.headBgImg.height) / 75}rem`
            };
        },
        // 奖品券的样式
        couponWrStyle() {
            return {
                height: `${parseInt(this.couponImg.height) / 75}rem`
            };
        },
        // 领取按钮
        receiveBtn() {
            return {
                height: `${parseInt(this.receiveBtnImg.height) / 75}rem`
            };
        },
        // 领取流程样式
        processStyle() {
            return {
                height: `${parseInt(this.processInfo.height) / 75}rem`
            };
        },
        // 额度介绍样式
        fqlAmountStyle() {
            return {
                height: `${parseInt(this.fqlAmountInfo.height) / 75}rem`
            };
        },
        // 登录弹层验证码class
        smsCodeClass() {
            return {
                gray: this.isSendSms
            };
        },
        // 协议弹层
        agreementClass() {
            return {
                mask: true,
                'mask-toggle': this.isShowAgreement
            };
        }
    },
    methods: {
        /** 
         * 展示规则弹层
         */
        showRule() {
            this.isLockPage = true;
            this.isShowRule = true;
        },
        /** 
         * 隐藏规则弹层
         */
        hideRule() {
            this.isLockPage = false;
            this.isShowRule = false;
        },
        /** 
         * 显示登录弹层
         */
        showLoginBox() {
            this.isLockPage = true;
            this.isShowLoginBox = true;
        },
        /** 
         * 隐藏规则弹层
         */
        hideLoginBox() {
            this.isLockPage = false;
            this.isShowLoginBox = false;
        },
        /** 
         * 显示协议弹层
         */
        showAgreement() {
            this.isLockPage = true;
            this.isShowAgreement = true;
        },
        /** 
         * 隐藏协议弹层
         */
        hideAgreement() {
            this.isLockPage = false;
            this.isShowAgreement = false;
        },
        /** 
         * 点击领取按钮
         */
        receivePrize() {
            if (!this.isSubLock) {
                Stat.clickStat(`CLICK_PAGE_RECEIVE_BTN_${this.source}_${this.activityId}`);

                // 未登录显示弹层
                if (!this.isLogin) {
                    this.showLoginBox();

                    Stat.clickStat(`SHOW_LOGIN_LAYER_${this.source}_${this.activityId}`);
                    return;
                }

                this.loadingIns = this.$tips.showLoading();
                this.isSubLock = true;
                // 已登录查询用户参与活动的资格
                this.checkUserStatus();
            }
        },
        /** 
         * 查询用户是否有参与活动的资格
         */
        checkUserStatus() {
            let activityId = parseInt(this.activityId);
            let params = {
                data: {
                    activity_id: activityId
                }
            };
            let url = '/route0007/invite/checkInActivity.json';

            this.$axios.post(url, params).then(res => {
                let data = res.data;
                let retcode = parseInt(data.retcode);
                let retmsg = data.retmsg;

                this.isSubLock = false;
                this.$tips.hideLoading(this.loadingIns);

                if (retcode == 0) {
                    let rows = data.result_rows || {};
                    let isAuth = rows.is_auth || 0; // 是否已授信
                    let isReceivePrize = rows.is_prize || 0; // 是否已领取奖品
                    let prizeRecordKey = rows.prize_record_key || '';   // 用户领奖凭证加密key

                    // 未授信跳转去授信
                    if (!isAuth) {
                        Util.locationHref(`${this.authLink}?agent=${this.agent}`);
                        return;
                    }

                    // 已领取奖品跳转去成功页
                    if (isReceivePrize) {
                        Util.locationHref(`${SUCCEED_PAGE}?activity_id=${this.activityId}`);
                        return;
                    }

                    Stat.clickStat(`CAN_RECEIVE_PRICE_${this.source}_${this.activityId}`);
                    // 跳转到领取奖品页
                    setTimeout(() => {
                        prizeRecordKey = encodeURIComponent(prizeRecordKey);
                        Util.locationHref(`${PRIZE_PAGE}?activity_id=${this.activityId}&prize_record_key=${prizeRecordKey}`);
                    }, 100);
                } else {
                    this.$tips.showError(retcode, retmsg); // 异常直接抛出错误文案
                }
            }).catch(err => {
                console.error(err);
                this.isSubLock = false;
                this.$tips.hideLoading(this.loadingIns);
            });
        },
        /**     
         * 点击获取验证码按钮
         */
        clickSendBtn() {
            // 校验手机号码是否填写 且 格式是否正确
            if (!this.mobile || !this.checkPhone(this.mobile)) {
                this.$tips('请输入正确的手机号码');
                return;
            }

            // 不在发送中倒计时 且 不在初始化过程中
            if (!this.isSendSms && !this.isLexinCaptchaInit) {
                this.initLexinCaptcha();

                Stat.clickStat(`GET_SMS_CODE_${this.source}_${this.activityId}`);
            }
        },
        /** 
         * 乐信行为验证平台-初始化
         */
        initLexinCaptcha() {
            let _this = this;
            this.isLexinCaptchaInit = true;
            this.isLexinCaptchaPass = false;
            this.loadingIns = this.$tips.showLoading();

            try {
                this.lexinCaptcha = new window.LexinCaptcha({
                    el: '#captcha-box',
                    appId: this.appId,
                    width: '350px',
                    // 初始化成功
                    onReady: function() {
                        _this.isLexinCaptchaInit = false;
                        _this.$tips.hideLoading(_this.loadingIns);

                        // 注意 this 指向问题，这个回调函数的 this 需要指向 window
                        this.verify();
                    },
                    // 行为验证成功
                    onSuccess: function(data) {
                        _this.isLexinCaptchaInit = false;

                        let result = data.result || {};
                        _this.lexinCaptchaSecondVerify(result);
                    },
                    // 错误
                    onError: function(data) {
                        _this.isLexinCaptchaInit = false;
                        try {
                            _this.$tips.hideLoading(_this.loadingIns);
                        } catch (e) {
                            // console.log(e);
                        }

                        let code = data.code;
                        let result = data.result || {};

                        switch (code) {
                            case -2: // 用户手动关闭验证码弹窗
                                _this.$tips('请按要求完成认证');
                                break;
                            case 'error_01': // 兼容多次刷新报错的情况
                                Stat.clickStat('CAPTCHA_REFRESH_TOO_MUCH');
                                break;
                            case 2: // 绕过供应商行为认证直接执行业务逻辑
                            case 310000:
                            case 510000:
                                _this.lexinCaptchaSecondVerify(result);
                                break;
                            case -6:
                                // 极验宕机
                                reportJsError({
                                    code: '913820007', // 服务宕机
                                    action: 'ad-geetest-downtime',
                                    msg: {
                                        msg: result || '',
                                        code: code || ''
                                    }
                                });
                                break;
                            default:
                                _this.$tips('获取验证码失败：'+ code);
                        }
                    },
                });
            } catch (err) {
                try {
                    this.$tips.hideLoading(this.loadingIns);
                } catch (e) {
                    // console.log(e);
                }
                this.isLexinCaptchaInit = false;
                this.$tips('[-1]获取验证码服务异常，请稍后再试');
                reportJsError({
                    code: '913820007', // 异常
                    msg: {
                        msg: err.message || ''                        
                    }
                });
            }
        },
        /** 
         * 乐信行为验证平台-二次校验
         */
        lexinCaptchaSecondVerify(validate) {
            let params = {
                data: {
                    captcha_param: validate, // 透传平台初始化验证成功返回的参数
                    mobile: this.mobile,
                    app_id: this.appId
                }
            };
            let url = '/route0007/work_loan_auth/captcha/second_verify.json';

            this.$axios.post(url, params).then(res => {
                let data = res.data;
                let retcode = +data.retcode;
                let retmsg = data.retmsg;

                if (retcode == 0) {
                    let rows = data.result_rows || {};
                    let status = rows.status || ''; // success-验证成功, fail-验证失败

                    if (status === 'success') {
                        this.verifyType = rows.verify_type || '';
                        this.verifiedMobile = this.mobile;
                        this.isLexinCaptchaPass = true;
                        this.isSendSms = true;
                        
                        this.$tips('短信验证码已发送');
                        this.countDown();
                    } else {
                        this.$tips('获取验证码失败，请重试');
                    }
                } else {
                    this.$tips.showError(retcode, retmsg);
                }
            });
        },
        /** 
         * 短信发送倒计时
         */
        countDown() {
            let sec = 60;

            this.sendText = '60秒后重试';
            this.countDownTimer = setInterval(() => {
                if (sec === 0) {
                    // 重置计时器
                    this.resetCountDown();
                } else {
                    sec--;
                    this.sendText = sec + '秒后重试';
                }
            }, 1000);
        },
        // 重置倒计时
        resetCountDown() {
            clearInterval(this.countDownTimer);
            this.isSendSms = false;
            this.sendText = '获取验证码';
            this.isLexinCaptchaPass = false; // 重置极验校验
        },
        /** 
         * 登录弹层领取按钮
         */
        submit() {
            // 是否处于提交中
            if (!this.isSubLock) {
                // 校验手机号码格式是否已填写 且 是否填写正确；用户未发短前直接点击提交
                if (!this.mobile || !this.checkPhone(this.mobile)) {
                    this.$tips('请输入正确的手机号码');
                    return;
                }

                // 极验未通过
                if (!this.isLexinCaptchaPass) {
                    this.$tips('请获取短信验证码');
                    return;
                }

                // 发送短信验证码的手机号和当前输入框的手机号不一致
                if (this.verifiedMobile && (this.verifiedMobile !== this.mobile)) {
                    this.$tips('请重新获取短信验证码');
                    this.isSendSms = false;
                    this.verifiedMobile = '';
                    return;
                }

                // 校验短信验证码是否已填写 且 是否填写正确
                if (!this.smsCode || !this.checkSms(this.smsCode)) {
                    this.$tips('请输入正确的短信验证码');
                    return;
                }

                // 提交验短进行登录
                this.isSubLock = true;
                this.loadingIns = this.$tips.showLoading();
                this.verifySms();
                Stat.clickStat(`LOGIN_LAYER_CLICK_RECEIVE_BTN_${this.source}_${this.activityId}`);
            }
        },
        /** 
         * 验证短信并登录
         */
        verifySms() {
            let verifyType = this.verifyType.toString();
            let params = {
                data: {
                    smsCode: this.smsCode,
                    verifyType: verifyType,
                    loginSceneType: 11 // 免密注册登录填10，像app那边场景（要求未填写未设置密码的用户需要走注册流程填11）
                }
            };
            let url = '/route0001/accountLoginService/mobileAuthSmsLogin.json';

            this.$axios.post(url, params).then(res => {
                let data = res.data;
                let retcode = +data.retcode;
                let retmsg = data.retmsg;

                if (retcode == 0) {
                    let rows = data.result_rows || {};
                    let flag = rows.flag || 0; // 是否登录成功，1是0否

                    if (flag) {
                        this.isLogin = true;
                        this.hideLoginBox();
                        this.checkUserStatus();
                        Stat.clickStat(`VERIFY_SMS_SUCCEED_AND_LOGIN_${this.activityId}_${this.source}`);
                    } else {
                        this.doRegister();
                        Stat.clickStat(`VERIFY_SMS_SUCCEED_AND_FAIL_LOGIN_${this.activityId}_${this.source}`);
                    }
                } else {
                    this.isSubLock = false;
                    this.$tips.hideLoading(this.loadingIns);
                    this.$tips.showError(retcode, retmsg);
                    Stat.clickStat(`VERIFY_SMS_FAIL_${this.activityId}_${this.source}`);
                }
            }).catch(err => {
                console.error(err);
                this.isSubLock = false;
                this.$tips.hideLoading(this.loadingIns);
            });
        },
        /** 
         * 平台免密注册
         */
        doRegister() {
            let extendParams = {
                agent_source: this.agentSource,     // 场景值
                agent: this.agent                   // 授信渠道码					
            };
            let params = {
                system: this.systemData,
                data: {
                    action: 'mobileRegister',
                    sceneType: 20,                              // 外部验证手机注册
                    channel_flag: this.channelFlag,             // 用户注册渠道来源
                    ext_auth_login_flag: 0,                     // 外部鉴权认证通过标识
                    passwdType: 2,                              // 系统设置密码
                    agent: this.agent,                          // 授信渠道码，注册也需要传入agent
                    allUrlParams: JSON.stringify(extendParams)  // 扩展参数
                }
            };
            let url = '/route0001/accountRegisterService/mobileRegister.json';

            this.$axios.post(url, params).then(res => {
                let data = res.data;
                let retcode = +data.retcode;
                let retmsg = data.retmsg;
                this.isSubLock = false;

                if (retcode == 0) {
                    Util.invokeJsBridge('onLogIn', {
                        url: location.href,
                        session_id: data.system.session_id,
                        token_id: data.system.token_id,
                        onReturn: function() {}
                    });

                    this.isLogin = true;
                    this.hideLoginBox();
                    this.checkUserStatus();
                    Stat.clickStat(`REGISTER_SUCCEED_${this.activityId}_${this.source}`);
                } else {
                    this.isSubLock = false;
                    this.$tips.hideLoading(this.loadingIns);
                    this.$tips.showError(retcode, retmsg);
                    Stat.clickStat(`REGISTER_FAIL_${this.activityId}_${this.source}`);
                }
            }).catch(err => {
                console.error(err);
                this.isSubLock = false;
                this.$tips.hideLoading(this.loadingIns);
            });
        },
        /** 
         * 手机号校验，1或9开头的数字，长度11位
         * 
         * @param {String} value [手机号]
         * @returns {Boolean} 校验结果
         */
        checkPhone(value) {
            return /^(1|9)\d{10}$/.test(value);
        },
        /** 
         * 校验短信验证码
         * 
         * @param {String} value [短信验证码]
         * @returns {Boolean} 校验结果
         */
        checkSms(value) {
            return /^\d{6}$/.test(value);
        },
        /** 
         * 失焦（软键盘隐藏之后），滚动到顶部
         */
        scrollToTop() {
            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        },
        /** 
         * 跳转到对应的协议页面
         * 
         * @param {String} url [跳转链接]
         */
        jumpToProtocol(url = '') {
            Util.locationHref(url);
        },
        /** 
         * 获取指定模板的配置
         * @param {Object} info [活动id基础配置]
         * @param {Object} config [pub上配置的信息]
         */
        getTemplateConfig(info, config) {
            // 取出当前活动的默认agent
            let { template, agent } = info;
            // 取出pub配置
            let {
                page_bg_color,
                page_theme_color,
                login_layer_main_title,
                login_layer_sub_title,
                login_layer_btn_text,
                rule_list,
                rule_layer_btn_text,
                page_title,
                head_bg_img,
                coupon_img,
                receive_btn_img,
                receive_btn_text,
                process_info,
                fql_amount_info
            } = config[template];

            this.agent = this.agent || agent;                           // 优先取url上的agent
            this.pageThemeColor = page_theme_color;                     // 统一主题颜色
            this.loginLayerMainTitle = login_layer_main_title;          // 登录弹层主文案
            this.loginLayerSubTitle = login_layer_sub_title;            // 登录弹层副文案
            this.loginLayerBtnText = login_layer_btn_text;              // 登录弹层按钮文案
            this.ruleList = rule_list;                                  // 规则列表
            this.ruleLayerBtnText = rule_layer_btn_text;                // 规则弹层按钮文案
            this.headBgImg = head_bg_img;                               // 主背景图
            this.couponImg = coupon_img;                                // 奖品图片
            this.receiveBtnImg = receive_btn_img;                       // 领取按钮图片
            this.receiveBtnText = receive_btn_text;                     // 领取按钮文案
            this.processInfo = process_info;                            // 领取流程
            this.fqlAmountInfo = fql_amount_info;                       // 分期乐额度介绍

            document.title = page_title;                                // 设置页面的标题
            document.body.style.background = page_bg_color;             // 设置body的背景颜色
        },
        /** 
         * 获取pub上的页面配置
         */
        getConfigData() {
            return new Promise((resolve, reject) => {
                let url = '/cgi/get_event_info.json';
                let data = {
                    params: {
                        event_id: G_EVENT_ID
                    }
                };

                this.$axios.get(url, data).then(res => {
                    let data = res.data;
                    let retcode = parseInt(data.retcode);
                    let retmsg = data.retmsg;

                    if (retcode == 0) {
                        let rows = data.result_rows || {};
                        this.isLogin = rows.is_login || 0; // 登录态

                        let config = rows.config || {};
                        let activityMap = config.activity_map || {};
                        let info = activityMap[this.activityId]; // 根据活动id获取基本信息
                        // 当前活动无映射关系 或者 无对应模板配置
                        if (!info || !Object.keys(config).includes(info.template)) {
                            this.$tips.showErrorPage('', EI21006);
                            return reject();
                        }
                        this.getTemplateConfig(info, config); // 取当前活动对应模板配置
                        this.configData = config;
                        this.appId = config.app_id || '48639d7bdf5ec2175e5a513c557caa90'; // 获取极验appid

                        resolve();
                    } else {
                        this.$tips.showError(retcode, retmsg);
                        reject();
                    }
                });
            });
        },
        /** 
         * 获取用户协议配置信息
         */
        getCommonConfig() {
            return new Promise((resolve, reject) => {
                let url = '/cgi/get_event_info.json';
                let data = {
                    params: {
                        event_id: 'common_config'
                    }
                };

                this.$axios.get(url, data).then(res => {
                    let data = res.data;
                    let retcode = parseInt(data.retcode);
                    let retmsg = data.retmsg || '';

                    if (retcode == 0) {
                        let rows = data.result_rows || {};
                        let config = rows.config || {};
                        let protocolList = config.protocol_list || [];

                        this.protocolList = protocolList; // 协议列表
                        resolve();
                    } else {
                        this.$tips.showError(retcode, retmsg);
                        reject();
                    }
                });
            });
        },
        // 初始化
        init() {
            this.loadingIns = this.$tips.showLoading();
            Promise.all([
                this.getConfigData(), // 获取页面配置
                this.getCommonConfig() // 获取协议配置
            ]).finally(() => {
                this.$tips.hideLoading(this.loadingIns);
            });

            // 获取场景值
            this.agentSource = AgentSource.getReportSource();
            
            Stat.clickStat(`${this.activityId}_SOURCE_${this.source}`);
        }
    },
    created() {
        // 必须先执行计算出rem的基准值
        Global.init();

        // url不存在activity_id，直接显示错误界面
        if (!this.activityId) {
            this.$tips.showErrorPage('', EI21006);
            return;
        }

        this.init();

        document.addEventListener('touchstart', function() {}, false); // 解决手机移动端active失效
    }
};
</script>

<style lang="less">
    @import '../../../../../global/mixin/core.less';
    @import './css/style.less';
</style>
